import React from 'react';
export function RealityCheckSection() {
  return <section className="py-24 bg-black relative flex items-center justify-center text-center" data-id="element-134">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-135" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-136">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-12 uppercase tracking-tighter" data-id="element-137">
          Jugar más horas{' '}
          <span className="text-red-600 line-through decoration-4 decoration-white" data-id="element-138">
            no te hace mejor
          </span>
        </h2>

        <div className="max-w-3xl mx-auto space-y-8" data-id="element-139">
          <p className="text-2xl text-slate-300 leading-relaxed" data-id="element-140">
            La mayoría pierde porque entra a partida{' '}
            <span className="text-white font-bold" data-id="element-141">sin plan</span>.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-lg md:text-xl font-medium text-slate-400" data-id="element-142">
            <div className="bg-slate-900/50 p-4 border-l-2 border-red-600" data-id="element-143">
              Se mueve por impulso
            </div>
            <div className="bg-slate-900/50 p-4 border-l-2 border-red-600" data-id="element-144">
              Busca kills sin estrategia
            </div>
            <div className="bg-slate-900/50 p-4 border-l-2 border-red-600" data-id="element-145">
              No lee el mapa
            </div>
            <div className="bg-slate-900/50 p-4 border-l-2 border-red-600" data-id="element-146">
              No controla su mente
            </div>
          </div>

          <div className="pt-8" data-id="element-147">
            <p className="text-2xl text-slate-300 italic mb-4" data-id="element-148">
              Y después dice: <span className="text-white" data-id="element-149">“mala suerte”</span>.
            </p>

            <div className="inline-block border-2 border-white px-8 py-4 transform -skew-x-12 bg-white text-black" data-id="element-150">
              <p className="text-3xl font-black transform skew-x-12 uppercase" data-id="element-151">
                No es mala suerte. Es falta de estructura.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}